// PostList.jsx
import React from 'react';
import PostPreview from './PostPreview'; // Adjust the path based on your project structure
import './PostList.css'; // Import the CSS file

const posts = [
  { 
    key: "c1424",
    value: {
      title: "Week 14 2024", 
      chartTitle:"Songs lost a minute since the 90s", 
      chartSubTitle: "The average song length went down from 4:19 in 1990 to 3:17 in 2020.", 
      image: '/images/previews/20240406_204721_cta_cw14.png',
      source: 'Statista 2022',
      sourceLink: 'https://www.statista.com/chart/26546/mean-song-duration-of-currently-streamable-songs-by-year-of-release/' 
    }
  },
  { 
    key: "c1324",
    value: {
      title: "Week 13 2024", 
      chartTitle:"Are Easter Gifts a Thing?", 
      chartSubTitle: "15% of Germans give toys at Easter. 35% give at least sweets and chocolate. 35% give nothing.", 
      image: '/images/previews/20240330_210355_cta_cw13.png',
      source: 'Statista 2022',
      sourceLink: 'https://de.statista.com/statistik/daten/studie/1302270/umfrage/umfrage-zur-wahl-der-ostergeschenke-in-deutschland/' 
    }
  },
  { 
    key: "c1224",
    value: {
      title: "Week 12 2024", 
      chartTitle:"Threads Losing Momentum in Q4 2023", 
      chartSubTitle: "From Q3 to Q4 2023, Threads dropped from 5th to 15th in global app downloads", 
      image: '/images/previews/20240319_115613_cta_cw12.png',
      source: 'Sensor Tower Q4 2023 Data Digest',
      sourceLink: 'https://go.sensortower.com/rs/351-RWH-315/images/Sensor-Tower-Q4-2023-Data-Digest.pdf' 
    }
  },
  { 
    key: "c1124",
    value: {
      title: "Week 11 2024", 
      chartTitle:"Oppenheimer Wins Oscars, Barbie Wins dollars", 
      chartSubTitle: "With a box office revenue of $1.4 billion, Barbie made 1.5 times as much as Oppenheimer", 
      image: '/images/previews/20240317_181944_cta_cw11.png',
      source: 'Box Office Mojo (March 2024)',
      sourceLink: 'https://www.boxofficemojo.com/showdown/sd205125124/' 
    }
  },
  { 
    key: "c1024",
    value: {
      title: "Week 10 2024", 
      chartTitle:"Growing Social Media User Base", 
      chartSubTitle: "For more than 10 years in a row, the number of social media users worldwide has continued to grow according to Statista", 
      image: '/images/previews/20240307_163811_cta_cw10.png',
      source: 'Statista (January 2024)',
      sourceLink: 'https://de.statista.com/statistik/daten/studie/739881/umfrage/monatlich-aktive-social-media-nutzer-weltweit/' 
    }
  },
  { 
    key: "cw0124-09",
    value: {
      title: "Week 09 2024", 
      chartTitle:"Driving Diversity in Tech", 
      chartSubTitle: "Around 60% of speakers at the Social Developers Conference 2024 in Hamburg will come from underrepresented groups", 
      image: '/images/previews/20240303_171705_cta_cw09.png',
      source: '@socialdevelopersclub (Instagram, Feburary 2024)',
      sourceLink: 'https://www.instagram.com/p/C34sQB5Ak99/' 
    }
  },
  { 
    key: "cw0124-08",
    value: {
      title: "Week 08 2024", 
      chartTitle:"AI-Generated Content Least Trusted by Boomers", 
      chartSubTitle: "One third of Baby Boomers are less likely to trust AI-generated content, followed by Gen X, Millenials, and Gen Z", 
      image: '/images/previews/20240224_212128_cta_cw08.png',
      source: 'hootsuite.com (January 2024)',
      sourceLink: 'https://hootsuite.widen.net/s/mgqjjznhsx/hootsuitesocialtrends2024_report_en' 
    }
  },
  { 
    key: "cw0124-07",
    value: {
      title: "Week 07 2024", 
      chartTitle:"Democracy threatened by online hate", 
      chartSubTitle: "Online hate causes one in two Germans to withdraw from discussions", 
      image: '/images/previews/20240216_222130_cta_cw07.png',
      source: 'Das NETTZ, Gesellschaft für Medienpädagogik und Kommunikationskultur, HateAid und Neue deutsche Medienmacher*innen als Teil des Kompetenznetzwerks gegen Hass im Netz (Hrsg.) (2024): Lauter Hass – leiser Rückzug. Wie Hass im Netz den demokratischen Diskurs bedroht. Ergebnisse einer repräsentativen Befragung. Berlin. https://kompetenznetzwerk-hass-imnetz.de/download_lauterhass.php',
      sourceLink: 'https://kompetenznetzwerk-hass-im-netz.de/wp-content/uploads/2024/02/Studie_Lauter-Hass-leiser-Rueckzug.pdf' 
    }
  },
  { 
    key: "cw0124-06",
    value: {
      title: "Week 06 2024", 
      chartTitle:"Android Dominates the Global OS Market", 
      chartSubTitle: "Since late 2020, Android holds the largest share of the operating system market, followed by Windows, iOS and MacOS", 
      image: '/images/previews/20240210_233921_cta_cw06.png',
      source: 'Operating System Market Share Worldwide 2019-2023 by statcounter.com',
      sourceLink: 'https://gs.statcounter.com/os-market-share' 
    }
  },
  { 
    key: "cw0124-05",
    value: {
      title: "Week 05 2024", 
      chartTitle:"Do You Spend 2+ Hours a Day on Social Media?", 
      chartSubTitle: "Most internet users between the ages of 16 and 64 spend an average of more than two hours on social media", 
      image: '/images/previews/20240203_130001_cta_cw05.png',
      source: 'We Are Social & Meltwater Digital 2024 (via datareportal.com)',
      sourceLink: 'https://datareportal.com/reports/digital-2024-deep-dive-the-time-we-spend-on-social-media' 
    }
  },
  { 
    key: "cw0124-04",
    value: {
      title: "Week 04 2024", 
      chartTitle:"Do We Really 'Like' AI-Generated Content?", 
      chartSubTitle: "Six in 10 consumers say they are less likely to engage with content that is known to be generated by AI", 
      image: '/images/previews/20240127_123505_cta_cw04.png',
      source: 'hootsuite.com (January 2024)',
      sourceLink: 'https://hootsuite.widen.net/s/mgqjjznhsx/hootsuitesocialtrends2024_report_en' 
    }
  },
  { 
    key: "cw0124-03",
    value: {
      title: "Week 03 2024", 
      chartTitle: 'United Against Right-Wing Extremism', 
      chartSubTitle: "Around 120 demonstrations took place over the weekend, spread across all of Germany's 16 federal states", 
      image: '/images/previews/20240127_111800_cta_cw03.png',
      source: 'correctiv.org (January 2024)',
      sourceLink: 'https://correctiv.org/wp-content/uploads/2024/01/Demoupdate_AFD_19.1-03.png' 
    }
  },
  { 
    key: "cw0124-02",
    value: {
      title: "Week 02 2024", 
      chartTitle: 'A Decade of Chrome Vulnerabilities', 
      chartSubTitle: 'Memory corruption most common: Regular browser updates can help keeping sensitive information safe', 
      image: '/images/previews/20240113_214419_cta_cw02.png',
      source: 'cvedetails.com (January 2024)',
      sourceLink: 'https://www.cvedetails.com/product/15031/Google-Chrome.html?vendor_id=1224'
    }
  },
  { 
    key: "cw0124-01",
    value: {
      title: 'Week 01 2024', 
      chartTitle: 'Learning To Code 2023', 
      chartSubTitle: '52% of the stack overflow survey respondents still used books and other printed resources', 
      image: '/images/previews/20240107_132423_cta_cw01.png',
      source: '2023 Developer Survey by Stack Overflow',
      sourceLink: 'https://survey.stackoverflow.co/2023/#section-learning-to-code-learning-how-to-code'
    }
  }
  
];

const PostList = () => {
    return (
      <div className="post-list">
        {posts.map((post, index) => (
          <PostPreview key={index} {...post.value} />
        ))}
      </div>
    );
  };
  

export default PostList;
